import React, { ReactNode } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

interface Props {
  children: ReactNode;
}

const PrivateRoute = ({ children, ...rest }: Props & RouteProps) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
